import {
  numberToCurrencyString,
  maskAccNumber,
  maskSortCode,
  maskIban,
} from 'further-ui/utils';

const commonColumns = () => [
  {
    label: 'Investor',
    key: 'investorFullName',
    sort: false,
    render: (elm) => `${elm?.fullName}`,
  },
  {
    label: 'Bank details',
    key: 'bankDetails',
    sort: false,
    render: (elm) => {
      const accNo = elm?.bankDetails?.bankAccountNumber;
      const sc = elm?.bankDetails?.bankSortCode;
      const iban = elm?.bankDetails?.iban;
      if (accNo && sc) return `${maskAccNumber(accNo)} ${maskSortCode(sc)}`;
      if (iban) return maskIban(iban);
      return 'No bank details found';
    },
  },
  {
    label: 'Cash balance',
    key: 'amountAvailable',
    sort: false,
    render: (elm) => {
      // Use maximumWithdrawable if available (consistent with spreadsheet validation)
      // Falls back to current cash balance if not set
      const availableAmount =
        elm?.withdrawalDetails?.maximumWithdrawable ??
        elm?.cashBalance?.cashBalance;
      return numberToCurrencyString(availableAmount);
    },
  },
];

export default commonColumns;
